import { AxiosError } from 'axios'
import { useMutation, UseMutationResult } from 'react-query'
import { useToast } from '@chakra-ui/toast'
import * as z from 'zod'

import { payloadSchema } from '@/features/OurProducts/schema'

import { fetchAPIv2 } from '@/lib/api'
import { useErrorHandler } from '@/lib/hooks'
import { acceptConsent } from '@/lib/utils/consent'

import { TOAST_CONFIG } from '@/lib/constants'

import env from '@/config/env'

type Payload = z.infer<typeof payloadSchema>

const contact = async (payload: Payload): Promise<void> => {
  await Promise.all([
    fetchAPIv2({
      url: env.APP_URL,
      prefix: '/api',
      path: '/our-products/contact',
      method: 'POST',
      data: payload,
    }),

    payload.agreedToMarketingConsent
      ? acceptConsent({
          apiKey: env.CONSENT_WOW_OTHER_PRODUCTS_API_KEY,
          purposeId: env.CONSENT_WOW_MARKETING_CONSENT_PURPOSE_ID,
          data: payload,
        })
      : Promise.resolve(null),
  ])
}

export const useContact = (): UseMutationResult<void, AxiosError, Payload> => {
  const toast = useToast()
  const handleError = useErrorHandler()

  return useMutation<void, AxiosError, Payload>(contact, {
    onSuccess: () => {
      toast({
        ...TOAST_CONFIG,
        description: 'เราได้รับการติดต่อจากคุณแล้ว',
      })
    },
    onError: handleError,
  })
}
